import { render, staticRenderFns } from "./user-reports-official-factor.vue?vue&type=template&id=3529cdff&"
import script from "./user-reports-official-factor.vue?vue&type=script&lang=js&"
export * from "./user-reports-official-factor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports